import {
    DetailsColumn,
    DetailsContainer,
    DetailsLabel,
    DetailsRow,
    DetailsText,
} from "../../../../constants/component.constants"
import ModalContainerModule from "../../../modules/modalContainer"

export default function ViewReminderModal(props) {
    /**
     *
     * REQUIRED PROPS:
     *
     * handleClose: func()
     * open: boolean
     * handleGenerateInvoice: func()
     *  notificationData: {
     *    date: string
     *    description: string
     *    type: string
     *  }
     */

    return (
      <ModalContainerModule
        size={
          props?.notificationData?.type === "Revenue Sharing"
            ? "sm"
            : "specialViewOrganizationNotification"
        }
        cancel={props.handleClose}
        openModal={props.open}
        {...(props.notificationData?.type === "Revenue Sharing"
          ? props.notificationData?.isCompleted
            ? { accept: props.handleGenerateInvoice, acceptButtonText: "Edit RSR" }
            : { accept: props.handleGenerateInvoice, acceptButtonText: "Complete RSR" }
          : {})}
        cancelText="Close"
        modalTitle="View Organization Notification"
      >
        <DetailsContainer sx={{ width: "100%", height: "100%", margin: 0 }}>
          <DetailsColumn sx={{ width: "100%", height: "100%", margin: 0 }}>
            <DetailsRow>
              <DetailsLabel>Type:</DetailsLabel>
              <DetailsText>
                {props.notificationData?.type ? `${props?.notificationData.type} (RSR)` : "--"}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Message:</DetailsLabel>
              <DetailsText>
                {props.notificationData
                  ? props.notificationData.description
                  : "--"}
              </DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Date:</DetailsLabel>
              <DetailsText>
                {props.notificationData ? props.notificationData.date : "--"}
              </DetailsText>
            </DetailsRow>
            <br />
            {props.notificationData?.type === "Revenue Sharing" && (
              <>
              <DetailsRow>
                <DetailsLabel>Completed:</DetailsLabel>
                <DetailsText>
                  {props.notificationData?.isCompleted
                    ? "Yes"
                    : "No"}
                </DetailsText>
              </DetailsRow>
              <DetailsRow>
              </DetailsRow>
              </>
            )}
          </DetailsColumn>
        </DetailsContainer>
      </ModalContainerModule>
    );
}
